"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dummyShader = void 0;
const gl_shader_1 = require("../gl-shader");
/**
 * @internal
 */
// @formatter:off
// language=GLSL
exports.dummyShader = new gl_shader_1.GlShader(`
void main()
{
}
`);
// @formatter:on
//# sourceMappingURL=dummy-shader.js.map